import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router";
import { Provider } from "react-redux";
import { LocaleProvider } from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import "moment/locale/zh-cn";
// Main Resources
import "antd/dist/antd.less";
import "./assets/less/index.less";

import routers from "./routers";

// Redux
import { store, history } from "./store";

ReactDOM.render(
  <Provider store={store}>
    <LocaleProvider locale={zhCN}>
      <Router history={history} routes={routers} />
    </LocaleProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js